( function( $ ) {
	
	$('.on-page-nav__content a').on('click', function(e){
		e.preventDefault();
		let nav_item_ID = $(this).attr('href');
		if( nav_item_ID.charAt( 0 ) === '#' ){
			nav_item_ID = nav_item_ID.slice( 1 );
			document.getElementById(nav_item_ID).scrollIntoView();
		}	
	});
	
	$('.component--sticky-accordion .accordion-item__header').on('click', function(e){
		var clickedIndex = $('.accordion-item__header').index(this);
		
		var setIndexes = [];
		
		$(this).parents('.item-list').find('.accordion-item__header').each(function(index){
			setIndex = $('.accordion-item__header').index(this);
			setIndexes.push(setIndex);
			
		});
		
		var indexForExclusion = setIndexes.indexOf(clickedIndex);
		
		var indexesForClosing = setIndexes.splice(indexForExclusion, 1);

		setIndexes.forEach(function(ind){
			indexElement = accordions[ind];
			var thing = new Accordion(indexElement);
			thing.close();
			
			var openCount = $('.component--sticky-accordion .accordion-item__trigger[aria-expanded="true"]').length;
			
			if(openCount > 0){
				$('.component--sticky-accordion .accordion-item__trigger').find('.accordion__item-title-text').removeClass('screen-reader-text');
				$('.component--sticky-accordion').addClass('has-open-item');
				$('.component--sticky-accordion .accordion-item__trigger .accordion__item-title span:last-of-type').show();
			}else if(openCount == 0){
				$('.component--sticky-accordion .accordion-item__trigger').find('.accordion__item-title-text').addClass('screen-reader-text');
				$('.component--sticky-accordion').removeClass('has-open-item');
				$('.component--sticky-accordion .accordion-item__trigger .accordion__item-title span:last-of-type').hide();
			}

		});
		
		
	});
	
	
	
} )( jQuery );